<template>
  <v-card>
    <v-card-title>
      <div>
        <div class="headline">Vessel Information</div>
      </div>
      <v-spacer></v-spacer>
    </v-card-title>
    <v-divider></v-divider>
    <v-card-text>
      <v-flex xs12 class="mt-3">
        <message :messages="messages"></message>
      </v-flex>
      <v-container fluid grid-list-lg>
        <v-layout row wrap>
          <v-flex xs6 v-if="newVessel">
            <v-text-field :label="labels.vesNo" v-model="vesselForm.vesNo" :error-messages="errors.collect('vesNo')" v-validate="'required|param|max:7'" data-vv-name="vesNo" :data-vv-as="labels.vesNo"></v-text-field>
          </v-flex>
          <v-flex xs6 v-else>
            <v-subheader class="queryLabel">{{labels.vesNoQuery}}</v-subheader>
            <div class="title">{{vesselForm.vesNo}}</div>
          </v-flex>
          <v-flex xs6>
            <v-text-field :label="labels.vesName" v-model="vesselForm.vesName" :error-messages="errors.collect('vesName')" v-validate="'required|entry|max:80'" data-vv-name="vesName" :data-vv-as="labels.vesName"></v-text-field>
          </v-flex>
          <v-flex xs12>
            <v-layout row wrap>
              <v-flex xs6>
                <v-text-field v-model="vesselForm.vesDesc" :label="labels.vesDesc" :error-messages="errors.collect('vesDesc')" v-validate="'required|entry|max:50'" data-vv-name="vesDesc" :data-vv-as="labels.vesDesc"></v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-text-field v-model="vesselForm.vesOwn" :label="labels.vesOwn" :error-messages="errors.collect('vesOwn')" v-validate="'entry|max:40'" data-vv-name="vesOwn" :data-vv-as="labels.vesOwn"></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs12>
            <v-layout row wrap>
              <v-flex xs6>
                <v-text-field v-model="vesselForm.vesAgt" :label="labels.vesAgt" :error-messages="errors.collect('vesAgt')" v-validate="'entry|max:8'" data-vv-name="vesAgt" :data-vv-as="labels.vesAgt"></v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-text-field v-model="vesselForm.yrBuilt" :label="labels.yrBuilt" :error-messages="errors.collect('yrBuilt')" v-validate="'required|integer|max:10'" data-vv-name="yrBuilt" :data-vv-as="labels.yrBuilt"></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs12>
            <v-layout row wrap>
              <v-flex xs6>
                <v-autocomplete :items="params.vesFlagList" v-model="vesselForm.vesFlag" :label="labels.vesFlag" item-text="label" item-value="value" data-vv-name="vesFlag" :data-vv-as="labels.vesFlag" :error-messages="errors.collect('vesFlag')" v-validate="'required'"></v-autocomplete>
              </v-flex>
              <v-flex xs6>
                <v-autocomplete :items="params.vesClsList" v-model="vesselForm.vesCls" :label="labels.vesCls" item-text="label" item-value="value" data-vv-name="vesCls" :data-vv-as="labels.vesCls" :error-messages="errors.collect('vesCls')" v-validate="'required'"></v-autocomplete>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs12>
            <v-layout row wrap>
              <v-flex xs6>
                <v-autocomplete :items="params.vesTypeList" v-model="vesselForm.vesType" :label="labels.vesType" item-text="label" item-value="value" data-vv-name="vesType" :data-vv-as="labels.vesType" :error-messages="errors.collect('vesType')" v-validate="'required'"></v-autocomplete>
              </v-flex>
              <v-flex xs6>
                <v-autocomplete :items="params.vesConstnList" v-model="vesselForm.vesConstn" :label="labels.vesConstn" item-text="label" item-value="value" data-vv-name="vesConstn" :data-vv-as="labels.vesConstn" :error-messages="errors.collect('vesConstn')" v-validate="'required'"></v-autocomplete>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs12>
            <v-layout row wrap>
              <v-flex xs6>
                <v-autocomplete :items="params.vesEngMakeList" v-model="vesselForm.vesEngMake" :label="labels.vesEngMake" item-text="label" item-value="value" data-vv-name="vesEngMake" :data-vv-as="labels.vesEngMake" :error-messages="errors.collect('vesEngMake')" v-validate="'required'"></v-autocomplete>
              </v-flex>
              <v-flex xs6>
                <v-autocomplete :items="params.vesEngModList" v-model="vesselForm.vesEngMod" :label="labels.vesEngMod" item-text="label" item-value="value" data-vv-name="vesEngMod" :data-vv-as="labels.vesEngMod" :error-messages="errors.collect('vesEngMod')" v-validate="'required'"></v-autocomplete>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs12>
            <v-layout row wrap>
              <v-flex xs6>
                <v-text-field v-model="vesselForm.grt" :label="labels.grt" :error-messages="errors.collect('grt')" v-validate="'numeric|max:10'" data-vv-name="grt" :data-vv-as="labels.grt"></v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-text-field v-model="vesselForm.nrt" :label="labels.nrt" :error-messages="errors.collect('nrt')" v-validate="'numeric|max:10'" data-vv-name="nrt" :data-vv-as="labels.nrt"></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs12>
            <v-layout row wrap>
              <v-flex xs6>
                <v-text-field v-model="vesselForm.dwt" :label="labels.dwt" :error-messages="errors.collect('dwt')" v-validate="'numeric|max:10'" data-vv-name="dwt" :data-vv-as="labels.dwt"></v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-text-field v-model="vesselForm.imoRefNo" :label="labels.imoRefNo" :error-messages="errors.collect('imoRefNo')" v-validate="'required|entry|max:40'" data-vv-name="imoRefNo" :data-vv-as="labels.imoRefNo"></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs12>
            <v-layout row wrap>
              <v-flex xs6>
                <v-text-field v-model="vesselForm.licenceNo" :label="labels.licenceNo" :error-messages="errors.collect('licenceNo')" v-validate="'required|entry|max:20'" data-vv-name="licenceNo" :data-vv-as="labels.licenceNo"></v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-text-field v-model="vesselForm.vesEngNo" :label="labels.vesEngNo" :error-messages="errors.collect('vesEngNo')" v-validate="'required|entry|max:20'" data-vv-name="vesEngNo" :data-vv-as="labels.vesEngNo"></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs12>
            <v-layout row wrap>
              <v-flex xs6>
                <v-text-field v-model="vesselForm.mds" :label="labels.mds" :error-messages="errors.collect('mds')" v-validate="'required|integer|max:10'" data-vv-name="mds" :data-vv-as="labels.mds"></v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-text-field v-model="vesselForm.length" :label="labels.length" :error-messages="errors.collect('length')" v-validate="'required|entry|max:20'" data-vv-name="length" :data-vv-as="labels.length"></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs12>
            <v-layout row wrap>
              <v-flex xs6>
                <v-text-field v-model="vesselForm.breath" :label="labels.breath" :error-messages="errors.collect('breath')" v-validate="'required|entry|max:20'" data-vv-name="breath" :data-vv-as="labels.breath"></v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-text-field v-model="vesselForm.depth" :label="labels.depth" :error-messages="errors.collect('depth')" v-validate="'required|entry|max:20'" data-vv-name="depth" :data-vv-as="labels.depth"></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs12>
            <v-layout row wrap>
              <v-flex xs6>
                <v-text-field v-model="vesselForm.hp" :label="labels.hp" :error-messages="errors.collect('hp')" v-validate="'required|integer|max:10'" data-vv-name="hp" :data-vv-as="labels.hp"></v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-text-field v-model="vesselForm.totCrew" :label="labels.totCrew" :error-messages="errors.collect('totCrew')" v-validate="'required|integer|max:10'" data-vv-name="totCrew" :data-vv-as="labels.totCrew"></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs12>
            <v-layout row wrap>
              <v-flex xs6>
                <v-text-field v-model="vesselForm.manufName" :label="labels.manufName" :error-messages="errors.collect('manufName')" v-validate="'required|entry|max:40'" data-vv-name="manufName" :data-vv-as="labels.manufName"></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>

          <v-flex xs12>
            <v-btn color="primary" type="submit" :loading="submitting" @click.prevent="doSave">
              {{newVessel? 'Add Vessel' : 'Update Vessel'}}
              <v-icon right>{{newVessel? 'mdi-calendar-plus' : 'mdi-content-save'}}</v-icon>
              </v-btn>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import MessageMixin from '@/mixins/message'
import { expandURI } from '@/utils/ajax'
import { extractMenu } from '@/utils/extract'
import { VESSEL_SIDEMENU } from '@/store/types'

export default {
  data() {
    return {
      labels: {
        vesNo: 'Vessel No*',
        vesNoQuery: 'Vessel No',
        vesName: 'Vessel Name*',
        vesDesc: 'Description*',
        vesOwn: 'Vessel Owner',
        vesAgt: 'Vessel Agent',
        yrBuilt: 'Year Built*',
        vesCls: 'Vessel Class*',
        vesConstn: 'Vessel Construction*',
        vesEngMake: 'Engine Make*',
        vesEngMod: 'Engine Model*',
        vesFlag: 'Vessel Flag*',
        vesType: 'Vessel Type*',
        grt: 'Gross Register Tonnage',
        nrt: 'Nett Register Tonnage',
        dwt: 'Dead Weight Tonnage',
        imoRefNo: 'IMO Reference No*',
        licenceNo: 'Licence No*',
        vesEngNo: 'Vessel Engine No*',
        mds: 'Min. Discernable Signal*',
        length: 'Length*',
        breath: 'Breath*',
        depth: 'Depth*',
        hp: 'Horse Power*',
        totCrew: 'Total Crew*',
        manufName: 'Manufacture Name*'
      },
      vesselForm: {
        vesNo: null,
        vesName: null,
        vesDesc: null,
        vesOwn: undefined,
        vesAgt: undefined,
        yrBuilt: undefined,
        vesCls: undefined,
        vesConstn: undefined,
        vesEngMake: undefined,
        vesEngMod: undefined,
        vesFlag: undefined,
        vesType: undefined,
        grt: undefined,
        nrt: undefined,
        dwt: undefined,
        imoRefNo: undefined,
        licenceNo: undefined,
        vesEngNo: undefined,
        mds: undefined,
        length: undefined,
        breath: undefined,
        depth: undefined,
        hp: undefined,
        totCrew: undefined,
        manufName: undefined
      },
      menu: [],
      newVessel: false,
      submitting: false,
      params: {
        vesClsList: [],
        vesConstnList: [],
        vesEngMakeList: [],
        vesEngModList: [],
        vesFlagList: [],
        vesTypeList: []
      }
    }
  },
  computed: {
    ...mapGetters([
      'checkAccess'
    ]),
    globalVesselSideMenu() {
      return this.$store.state.vessel.sideMenu
    }
  },
  methods: {
    ...mapActions([
      'vesselInit'
    ]),
    async doInit() {
      if (!this.newVessel) {
        // Review
        await this.reviewVessel(this.vesNo)
      }
    },
    async doInitList() {
      const apiURI = this.$store.state.vessel.menu.classList
      if (apiURI) {
        try {
          const result = await this.$http.get(apiURI)
          const { data } = result.data
          if (data) {
            this.$set(this.params, 'vesClsList', result.data.data.classList)
          }
        } catch (err) {
          throw err
        }
      }

      const apiURI2 = this.$store.state.vessel.menu.constnList
      if (apiURI2) {
        try {
          const result = await this.$http.get(apiURI2)
          const { data } = result.data
          if (data) {
            this.$set(this.params, 'vesConstnList', result.data.data.constnList)
          }
        } catch (err) {
          throw err
        }
      }

      const apiURI3 = this.$store.state.vessel.menu.engMakeList
      if (apiURI3) {
        try {
          const result = await this.$http.get(apiURI3)
          const { data } = result.data
          if (data) {
            this.$set(this.params, 'vesEngMakeList', result.data.data.engMakeList)
          }
        } catch (err) {
          throw err
        }
      }

      const apiURI4 = this.$store.state.vessel.menu.engModList
      if (apiURI4) {
        try {
          const result = await this.$http.get(apiURI4)
          const { data } = result.data
          if (data) {
            this.$set(this.params, 'vesEngModList', result.data.data.engModList)
          }
        } catch (err) {
          throw err
        }
      }

      const apiURI5 = this.$store.state.vessel.menu.flagList
      if (apiURI5) {
        try {
          const result = await this.$http.get(apiURI5)
          const { data } = result.data
          if (data) {
            this.$set(this.params, 'vesFlagList', result.data.data.flagList)
          }
        } catch (err) {
          throw err
        }
      }

      const apiURI6 = this.$store.state.vessel.menu.typeList
      if (apiURI6) {
        try {
          const result = await this.$http.get(apiURI6)
          const { data } = result.data
          if (data) {
            this.$set(this.params, 'vesTypeList', result.data.data.typeList)
          }
        } catch (err) {
          throw err
        }
      }
    },
    async reviewVessel(xVesNo) {
      const apiURI = this.$store.state.vessel.menu.getVslDet
      if (apiURI) {
        try {
          const expand = {
            vesNo: xVesNo
          }
          const result = await this.$http.get(expandURI(apiURI, expand))
          const { data } = result.data
          if (data) {
            // Vessel init
            this.vesselForm.vesNo = data.vessel.vesNo
            this.vesselForm.vesName = data.vessel.vesName
            this.vesselForm.vesDesc = data.vessel.vesDesc
            this.vesselForm.vesOwn = data.vessel.vesOwn
            this.vesselForm.vesAgt = data.vessel.vesAgt
            this.vesselForm.yrBuilt = data.vessel.yrBuilt
            this.vesselForm.vesCls = data.vessel.vesCls
            this.vesselForm.vesConstn = data.vessel.vesConstn
            this.vesselForm.vesEngMake = data.vessel.vesEngMake
            this.vesselForm.vesEngMod = data.vessel.vesEngMod
            this.vesselForm.vesFlag = data.vessel.vesFlag
            this.vesselForm.vesType = data.vessel.vesType
            this.vesselForm.vesClsDesc = data.vessel.vesClsDesc
            this.vesselForm.vesConstnDesc = data.vessel.vesConstnDesc
            this.vesselForm.vesEngMakeDesc = data.vessel.vesEngMakeDesc
            this.vesselForm.vesEngModDesc = data.vessel.vesEngModDesc
            this.vesselForm.vesFlagDesc = data.vessel.vesFlagDesc
            this.vesselForm.vesTypeDesc = data.vessel.vesTypeDesc
            this.vesselForm.grt = data.vessel.grt
            this.vesselForm.nrt = data.vessel.nrt
            this.vesselForm.dwt = data.vessel.dwt
            this.vesselForm.imoRefNo = data.vessel.imoRefNo
            this.vesselForm.licenceNo = data.vessel.licenceNo
            this.vesselForm.vesEngNo = data.vessel.vesEngNo
            this.vesselForm.mds = data.vessel.mds
            this.vesselForm.length = data.vessel.length
            this.vesselForm.breath = data.vessel.breath
            this.vesselForm.depth = data.vessel.depth
            this.vesselForm.hp = data.vessel.hp
            this.vesselForm.totCrew = data.vessel.totCrew
            this.vesselForm.manufName = data.vessel.manufName

            // Extract menu
            this.menu = extractMenu(result.data._links)
          }
        } catch (error) {
          throw error
        }
      } else {
        this.$snotify.error('Invalid API URL')
      }
    },
    doSave() {
      this.resetMessages()
      this.$validator.validateAll().then(result => {
        if (result) {
          if (this.newVessel) {
            this.doCreate()
          } else {
            this.doUpdate()
          }
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async doUpdate() {
      const apiURI = this.menu.updateVslDet
      if (apiURI) {
        this.submitting = true
        try {
          const result = await this.$http.put(apiURI, this.vesselForm)
          const { data } = result
          if (data) {
            // Show message via notify
            this.notify(data)
            await this.reviewVessel(this.vesselForm.vesNo)
            // Stay on page
            let newSideMenu = []
            newSideMenu.push({ name: 'vesselReview', text: 'Vessel' })
            newSideMenu.push({ name: 'vesselVoyageReview', text: 'Voyages' })

            this.$store.commit(VESSEL_SIDEMENU, newSideMenu)
          }
          this.submitting = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.submitting = false
        }
      } else {
        this.$snotify.error('Invalid API URL')
      }
    },
    async doCreate() {
      const apiURI = this.$store.state.vessel.menu.createVslDet
      if (apiURI) {
        this.submitting = true
        try {
          const result = await this.$http.post(apiURI, this.vesselForm)
          const { data } = result

          if (data) {
            // Show message via notify
            this.notify(data)

            // Stay on page
            this.newVessel = false
            this.$router.push({ name: 'vesselReview', params: { vesNo: this.vesselForm.vesNo } })
            await this.reviewVessel(this.vesselForm.vesNo)

            let newSideMenu = []
            newSideMenu.push({ name: 'vesselReview', text: 'Vessel' })
            newSideMenu.push({ name: 'vesselVoyageReview', text: 'Voyages' })

            this.$store.commit(VESSEL_SIDEMENU, newSideMenu)
          }
          this.submitting = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.submitting = false
        }
      } else {
        this.$snotify.error('Invalid API URL')
      }
    }
  },
  created() {
    this.doInitList()
    if (this.vesNo === 'New') {
      this.newVessel = true
    } else {
      this.doInit()
    }
  },
  props: {
    vesNo: {
      type: String,
      default: ''
    }
  },
  mixins: [
    MessageMixin
  ]
}
</script>

<style lang="scss">

</style>
